module.exports = __webpack_public_path__ + "img/template_placeholder_purple@2x.1d190c9.png";